import React from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import { Redirect } from "react-router";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { createStore, applyMiddleware } from "redux";
import { connect } from "react-redux";
import { createBrowserHistory } from "history";
import logo from "./logo.svg";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Dashboard from "./components/dashboard";
// import Example from "./components/example";
// import Maps from "./components/maps";
import Map from "./components/map";
//import Lmap1 from "./components/lmap1";
import Header from "./components/header";
import Ulb from "./components/ulb";
import Agency from "./components/agency";
import Home from "./components/home";
import Login from "./components/login/login";
import SelectWorkOrder from "./components/selectWOrkOrder";
import AddUser from "./components/userActions/addUser";
import DeleteUser from "./components/userActions/deleteUser";
import EditUser from "./components/userActions/editUser";
import ListUser from "./components/userActions/listUsers";
import AddClient from "./components/clientActions/addClient";
import DeleteClient from "./components/clientActions/deleteClient";
import EditClient from "./components/clientActions/editClient";
import ListClient from "./components/clientActions/listClients";
import Ward from "./components/ward";
import Property from "./components/property";
import AgencyReport from "./components/agencyReport";
import UserReport from "./components/userReport";

import Dummy from "./components/dummyComponent";
//import Ant from "./components/antdTree";
import rootReducer from "./reducers/index";

import ZipprData from "./components/zipprData";
import PrivateRoute from './PrivateRoute';
import LoginRedirect from './LoginRedirect';

const store = createStore(rootReducer, applyMiddleware(thunk));
let showWorkorderComponent = false;

const routerContext = React.createContext(null);
let history = createBrowserHistory();
let count = 1;

let loginDetails = localStorage.getItem("loginDetails");
if (loginDetails) {
  loginDetails = JSON.parse(loginDetails);
}
// export function App() {
export class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      workOrder: "",
      loginDetails
    };
  }

  componentDidMount() {
    let loginDetails = localStorage.getItem("loginDetails");

    if (loginDetails) {
      loginDetails = JSON.parse(loginDetails);
    }
    this.setState({
      loginDetails
    });
  }

  render() {
    //     if(window.location.pathname=='/'){
    //       showWorkorderComponent=true
    //       //console.log(this.props,"this.props in App...")

    //  }else{
    //   showWorkorderComponent=false
    //  }
    console.log(this.state.loginDetails, "this.state.loginDetails...");

    let workOrder = localStorage.getItem("workOrderObj");
    let session = localStorage.getItem("loginDetails");
    console.log(session, "session");
    workOrder = JSON.parse(workOrder);
    let work_order;
    if (workOrder) {
      work_order = workOrder.workOrder;
    } else {
      work_order = "";
    }

    console.log(workOrder, "workOrderworkOrder");

    return (
      <div className="App">
        <Provider store={store}>
          <Router history={history}>
            {/* <Route path='/' component={Header}></Route> */}
            {window.location.pathname == "/login" ? (
              ""
            ) : (
              <Route path="/" component={Header}></Route>
            )}
            {/* <Route path='/' component={Header}></Route> */}
            {/* { !session && window.location.pathname!=='/login' ?
       <Route path='/' component={Login}></Route>
       : */}

            <Switch>
              {/* <LoginRedirect> */}
                <Route path="/login" component={Login}></Route>
              {/* </LoginRedirect> */}
              {/* {this.state.loginDetails ? ( */}
              <>
                <PrivateRoute>
                  <Route path="/zippr" component={ZipprData}></Route>
                  <Route path="/dashbord" component={Dashboard}></Route>
                  <Route path="/home" component={Home}></Route>
                  <Route path="/map" component={Map}></Route>
                  <Route path="/addUser" component={AddUser}></Route>
                  <Route path="/editUser" component={EditUser}></Route>
                  <Route path="/listUsers" component={ListUser}></Route>
                  <Route path="/deleteUser" component={DeleteUser}></Route>
                  <Route path="/addClient" component={AddClient}></Route>
                  <Route path="/editClient" component={EditClient}></Route>
                  <Route path="/deleteClient" component={DeleteClient}></Route>
                  <Route path="/listClients" component={ListClient}></Route>
                  <Route path="/ulb" component={Ulb}></Route>
                  <Route path="/agency" component={Agency}></Route>
                  {/* <Route path="/ward" component={Ward}></Route> */}
                  <Route path="/ward" component={Property}></Route>
                  <Route path="/agencyReport" component={AgencyReport}></Route>
                  <Route path="/userReport" component={UserReport}></Route>
                  <Route
                    path="/selectWorkOrder"
                    component={SelectWorkOrder}
                  ></Route>

                  <Route path="/dummy" component={Dummy}></Route>
                </PrivateRoute>
              </>
              // ) : ( // redirectToLogin() // )}
            </Switch>
          </Router>
        </Provider>
      </div>
    );
  }
}

const mapStateToProps = ({ store }) => ({
  count: store
});

function redirectToLogin() {
  console.log("redcttohome");
  count++;
  console.log(count, "counttt");
  // window.location.href='/login';
  let path = window.location.pathname;
  if (count <= 2 && path != "/login") {
    // window.location.assign("/login")
    window.location.href = "/login";
  }
}

export default connect(mapStateToProps)(App);
